export const SET_NEW_ACCOUNT_USERNAME = 'SET_NEW_ACCOUNT_USERNAME';
export const SET_NEW_ACCOUNT_EMAIL = 'SET_NEW_ACCOUNT_EMAIL';
export const NEW_ACCOUNT_VALIDATING_USERNAME = 'NEW_ACCOUNT_VALIDATING_USERNAME';
export const NEW_ACCOUNT_USERNAME_VALID = 'NEW_ACCOUNT_USERNAME_VALID';
export const NEW_ACCOUNT_USERNAME_INVALID = 'NEW_ACCOUNT_USERNAME_INVALID';
export const NEW_ACCOUNT_REQUEST_SUBMITTED = 'NEW_ACCOUNT_REQUEST_SUBMITTED';
export const ACCOUNT_REQUESTS_ENABLED = 'ACCOUNT_REQUESTS_ENABLED';
